module.exports = __webpack_public_path__ + "static/img/music.fabd90f5.png";